module.exports = __webpack_public_path__ + "assets/img/Methodist Girls' School.08fdb4d4.jpg";